/* =========================================================
   Members lander — Supabase OTP login
   ---------------------------------------------------------
   Login only. Two views in the card (sections/page-members.liquid):
     #mp-email-view   email entry          → MPPortal.sendOtp
     #mp-otp-view     one-time code entry  → MPPortal.verifyOtp
   On success (or if already signed in) → redirect to ACCOUNT_URL.
   The signed-in dashboard lives on its own page (page-account.liquid).

   Depends on window.MPPortal (assets/customer-portal.js), loaded just before.
   ========================================================= */

(function () {
  'use strict';

  var ACCOUNT_URL = '/pages/account';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function waitForPortal(cb) {
    if (window.MPPortal) return cb();
    var tries = 0;
    var t = setInterval(function () {
      if (window.MPPortal || tries++ > 100) {
        clearInterval(t);
        if (window.MPPortal) cb();
      }
    }, 50);
  }

  ready(function () { waitForPortal(init); });

  function init() {
    var P = window.MPPortal;
    if (!P) return;

    // Already signed in → skip the login page entirely.
    if (P.hasStoredSession()) {
      window.location.replace(ACCOUNT_URL);
      return;
    }

    var views = {
      email: document.getElementById('mp-email-view'),
      otp: document.getElementById('mp-otp-view')
    };

    var emailForm = document.getElementById('mp-lander-form');
    var emailInput = document.getElementById('mp-lander-email');
    var emailBtn = document.getElementById('mp-lander-btn');
    var emailStatus = document.getElementById('mp-lander-status');

    var otpForm = document.getElementById('mp-otp-form');
    var otpInput = document.getElementById('mp-otp-code');
    var otpBtn = document.getElementById('mp-otp-btn');
    var otpStatus = document.getElementById('mp-otp-status');
    var otpEmailEcho = document.getElementById('mp-otp-email');
    var otpResend = document.getElementById('mp-otp-resend');
    var otpBack = document.getElementById('mp-otp-back');

    var currentEmail = '';

    function show(name) {
      if (views.email) views.email.hidden = (name !== 'email');
      if (views.otp) views.otp.hidden = (name !== 'otp');
    }

    function setLoading(btn, on) {
      if (!btn) return;
      btn.disabled = on;
      var text = btn.querySelector('.mp-lander__btn-text');
      var spin = btn.querySelector('.mp-lander__btn-spin');
      if (text) text.hidden = on;
      if (spin) spin.hidden = !on;
    }

    function status(el, msg, isError) {
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
      el.classList.toggle('is-error', !!isError);
    }

    show('email');

    // --- Email step ---
    if (emailForm) {
      emailForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        var email = (emailInput.value || '').trim();
        if (!email || !emailInput.validity.valid) {
          emailInput.focus();
          status(emailStatus, 'Please enter a valid email address.', true);
          return;
        }
        setLoading(emailBtn, true);
        status(emailStatus, '');
        try {
          await P.sendOtp(email);
          currentEmail = email;
          if (otpEmailEcho) otpEmailEcho.textContent = email;
          show('otp');
          status(otpStatus, '');
          if (otpInput) { otpInput.value = ''; otpInput.focus(); }
        } catch (err) {
          status(emailStatus, err.message || 'We could not send your code. Please try again.', true);
        } finally {
          setLoading(emailBtn, false);
        }
      });
    }

    // --- OTP step ---
    if (otpForm) {
      otpForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        var code = (otpInput.value || '').trim();
        if (!code) {
          otpInput.focus();
          status(otpStatus, 'Enter the code we emailed you.', true);
          return;
        }
        setLoading(otpBtn, true);
        status(otpStatus, '');
        try {
          await P.verifyOtp(currentEmail, code);
          // Signed in — hand off to the standalone account page.
          window.location.href = ACCOUNT_URL;
        } catch (err) {
          status(otpStatus, err.message || 'That code is invalid or expired.', true);
          setLoading(otpBtn, false);
        }
      });
    }

    if (otpResend) {
      otpResend.addEventListener('click', async function (e) {
        e.preventDefault();
        if (!currentEmail) { show('email'); return; }
        status(otpStatus, 'Sending a new code…');
        try {
          await P.sendOtp(currentEmail);
          status(otpStatus, 'A new code is on its way.', false);
        } catch (err) {
          status(otpStatus, 'Could not resend the code. Please try again.', true);
        }
      });
    }

    if (otpBack) {
      otpBack.addEventListener('click', function (e) {
        e.preventDefault();
        show('email');
      });
    }
  }
})();
